module.exports = __webpack_public_path__ + "img/instagram-icon.9db263dc.svg";